import dayjs from "dayjs";
import SVG from "react-inlinesvg";
import dynamic from "next/dynamic";
import { Fragment } from "react";
import defaultAuthor from "@/constants/defaultAuthor";
// import { useWindowSize } from "@/hooks/useIsMobile";
import siteInfo from "@/constants/siteInfo";
import sendGAEvent from "@/utils/gaEvent";
//import AdSlot300x250 from "../Ads/AdSlot300x250";
// const VDOAdSlot = dynamic(() => import("@/component/Ads/VDOAdSlot"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));

const Card = ({ content, isLCP = false, haveH2 = false }) => {
  return (
    <div className="flex flex-col overflow-hidden">
      <div className="flex-shrink-0">
        <div className="relative">
          <a
            href={content?.canonical_url ?? ""}
            onClick={() => {
              let eventName = `Video Click - Video Tab`;
              sendGAEvent({
                eventName: eventName,
                pageTitle: document?.title,
                pageLocation: window?.location?.href,
              });
            }}
          >
            <img
              className=" w-full object-cover rounded-md"
              src={`${content?.image_small}?size=320:180`}
              title={content?.image_title}
              alt={
                content?.image_small_alt_text
                  ? content?.image_small_alt_text
                  : content?.image_title
                  ? content?.image_title
                  : siteInfo?.siteName
              }
              fetchpriority={isLCP ? "high" : "low"}
              loading={isLCP ? "eager" : "lazy"}
              role="button"
              height={180}
              width={320}
            />
          </a>
          {/* Conditionally render the play icon if the content type is video */}
          {content?.content_type === "video" && (
            <a href={content?.canonical_url ?? ""}>
              <div
                role="button"
                className="absolute inset-0 flex justify-center items-center"
              >
                <SVG
                  className="w-10 h-10"
                  src="/assets/icons/svg/play-media.svg"
                />
              </div>
            </a>
          )}
        </div>
      </div>

      <div className="py-2">
        <a
          href={content?.canonical_url ?? ""}
          onClick={() => {
            let eventName = `Video Click - Video Tab`;
            sendGAEvent({
              eventName: eventName,
              pageTitle: document?.title,
              pageLocation: window?.location?.href,
            });
          }}
        >
          {haveH2 ? (
            <h3
              className="text-md font-bold line-clamp-3 hover:text-primary"
              dangerouslySetInnerHTML={{
                __html: `${content?.title_short}`,
              }}
            />
          ) : (
            <h3
              className="text-md font-bold line-clamp-3 hover:text-primary"
              dangerouslySetInnerHTML={{
                __html: `${content?.title_short}`,
              }}
            />
          )}
        </a>
        <p className="text-xs text-gray-500 font-extralight mt-1 mb:text-sm xs:text-sm">
          <img
            className="h-[16px] w-[16px] inline-block mr-1"
            alt="read video icon"
            src={
              content?.content_type === "video"
                ? "/assets/icons/svg/watchType.svg"
                : "/assets/icons/svg/readType.svg"
            }
          />
          <time dateTime={content?.datetime_published}>
            {dayjs(content?.datetime_published).format("MMM DD YYYY")}
          </time>{" "}
          · By{" "}
          <a
            href={
              content?.author?.[0]?.canonical_url ??
              defaultAuthor?.canonical_url
            }
            className={haveH2 ? "inline-block" : ""}
          >
            {haveH2 ? (
              <h4 className="text-primary">
                {content?.author?.[0]?.title ?? defaultAuthor.title}
              </h4>
            ) : (
              <span className="text-primary">
                {content?.author?.[0]?.title ?? defaultAuthor.title}
              </span>
            )}
          </a>
        </p>
      </div>
    </div>
  );
};





const NewsGrid = ({
  title,
  icon = "",
  newsListData = null,
  isLCP = false,
  showAds = false,
  haveH1 = false,
  scrolled=false
}) => {
  // const size = useWindowSize();
  return (
    <div className="my-2">
      <div className="flex my-2 items-center">
        {icon && (
          <SVG
            className="text-primary font-bold text-2xl w-7 h-7 inline mr-2 min-w-[29px]"
            src={icon}
          />
        )}
        <div className="text-primary font-bold text-2xl mb:font-extrabold sm:font-extrabold xs:font-extrabold">
          {haveH1 ? <h1>{title ?? "न्यूज़"}</h1> : <h2>{title ?? "न्यूज़"}</h2>}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-2">
        {newsListData?.map((content, index) => (
          <Fragment key={index}>
            <div>
              <Card
                content={content}
                isLCP={index === 0 ? isLCP : false}
                haveH2={haveH1}
              />
            </div>
            {index === 2 && (
              <div
                className="md:col-span-3 lg:col-span-3"
                style={{ gridColumn: "1 / -1" }}
              >
                {/* {showAds && <VDOAdSlot />} */}
              </div>
            )}
            {index === 8 &&scrolled&& (
              <div className="md:col-span-3 lg:col-span-3">
                {/* Render your Ad Card here */}
                <AdSlot300x250
                  divId="div-gpt-ad-1659434604998-0"
                  minWidth="300px"
                  minHeight="250px"
                />
                <AdSlot728x90
                  divId="div-gpt-ad-1707804176041-2"
                  minWidth="720px"
                  minHeight="90px"
                />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default NewsGrid;
